import React, { useEffect, useRef, useState } from 'react';

const FadeReveal = ({ 
    children, 
    direction = 'up', 
    delay = 0, 
    className = '', 
    style = {},
    threshold = 0.15,
    rootMargin = '0px 0px -50px 0px'
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const domRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold, rootMargin });

        const currentRef = domRef.current;
        if (currentRef) observer.observe(currentRef);

        return () => {
            if (currentRef) observer.unobserve(currentRef);
        };
    }, []);

    return (
        <div 
            ref={domRef} 
            className={`fade-reveal ${direction} ${isVisible ? 'is-visible' : ''} ${className}`}
            style={{ transitionDelay: `${delay}s`, ...style }}
        >
            {children}
        </div>
    );
};

export default FadeReveal;
